import axios from "axios";
import { BASE_URL, restGet, restPost, restPostLogin } from "./RestClient";


export async function profileUpdate(data, email) {
	const res = await restPost(`Ads_Clients/ProfileUpdate_AdsClients/${email}`, data);
	return res.data;
}